import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translations from '../lang/en.json'
import translations2 from '../lang/cn.json'
import store from '~/store'

Vue.use(VueI18n)

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD'
    },
    currencyNoCents: {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
      maximumFractionDigits: 0
    }
  },
  'en-GB': {
    currency: {
      style: 'currency', currency: 'GBP'
    },
    currencyNoCents: {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
      maximumFractionDigits: 0
    }
  },
  'en-SG': {
    currency: {
      style: 'currency', currency: 'SGD'
    },
    currencyNoCents: {
      style: 'currency',
      currency: 'SGD',
      minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
      maximumFractionDigits: 0
    }
  },
  'zh-SG': {
    currency: {
      style: 'currency', currency: 'SGD'
    },
    currencyNoCents: {
      style: 'currency',
      currency: 'SGD',
      minimumFractionDigits: 0, // set fraction digits to 0 to remove cents
      maximumFractionDigits: 0
    }
  }
}

const i18n = new VueI18n({
  locale: store.getters['config/language'] || 'en-SG',
  numberFormats,
  messages: {
    'en-SG': translations,
    'zh-SG': translations2
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/plugins/vue-i18n.js